import { useState } from "react";
import { JobPost } from "@/types/jobPost";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";

export const useFlagJobPostError = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const flagJobPostError = async (
    jobPostId: JobPost["id"],
    errorDetails: JobPost["error_details"],
  ) => {
    setLoading(true);
    setError(null);
    setSuccess(null);

    const authToken = localStorage.getItem("authToken");

    if (!authToken) {
      setError("Not authenticated.");
      setLoading(false);
      return;
    }

    try {
      const response = await axiosInstance.post(
        "jobs/job_posts/flag_error/",
        {
          job_post_id: jobPostId,
          error_detail: errorDetails,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      setSuccess(response.data.message);
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        setError(err.message);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unknown error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  return { flagJobPostError, loading, error, success };
};
